import React from 'react'
import { useState, useEffect } from 'react'
import { json, useParams } from 'react-router-dom'

import Header from '../common/Header'
import SideMenu from '../common/SideMenu'

import GachaEffect from './Modal/GachaEffect'

import './Shop.css'
import { useTranslation } from "react-i18next";


const ShopEdit = ({ onlyShop }) => {
  const { t } = useTranslation();
  const [isGachaEffectModalOpen, setIsGachaEffectModalOpen] = useState(false);

  const openModal = () => {
    setIsGachaEffectModalOpen(true);
  }

  const closeModal = () => {
    setIsGachaEffectModalOpen(false);
  }

  const { shop } = useParams();
  
  const [effects, setEffects] = useState([]);

  const getShop = async () => {
    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
      xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
      token = token.split('=')[1]
    }
    fetch(process.env.REACT_APP_API_URL + '/api/shop', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token),
      },
      credentials: 'include',
    })
      .then(response => response.json())
      .then(data => {
        let shop = data.shop;
        const effectType = shop.effect_pattern ? shop.effect_pattern : 1;
        setShopInfo({
          userId: shop.shop_user_id ? shop.shop_user_id : "",
          name: shop.name ? shop.name : "",
          postalCode: shop.postal_code ? shop.postal_code : "",
          address: shop.address ? shop.address : "",
          email: shop.email ? shop.email : "",
          url: shop.url ? shop.url : "",
          address: shop.address ? shop.address : "",
          personInCharge: shop.person_in_charge ? shop.person_in_charge : "",
          specialCommercialLaw: shop.special_commercial_law ? shop.special_commercial_law : "",
          privacyPolicy: shop.privacy_policy ? shop.privacy_policy : "",
          useTerm: shop.use_terms ? shop.use_terms : "",
          userPaymentTerms: shop.user_payment_terms ? shop.user_payment_terms : "",
          platformCardPurchaseTerms: shop.platform_card_purchase_terms ? shop.platform_card_purchase_terms : "",
          secondhandDealerLicenseNumber: shop.secondhand_dealer_license_number,
          faviconUrl: shop.favicon_url ? shop.favicon_url : "/static/default/favicon.png",
          logoUrl: shop.logo_url ? shop.logo_url : "/static/default/logo.png",
          designType: shop.design_pattern ? shop.design_pattern : 1,
          effectType,
          shipFee: shop.ship_fee ? shop.ship_fee : 0,
          originalEffectPattern: shop.original_effect_pattern,
          noteTitle: shop.note_title ? shop.note_title : "",
          noteContent: shop.note_content ? shop.note_content : "",
          holdDays: shop.hold_days ? shop.hold_days : "",
          shippingAfterDays: shop.shipping_after_days ? shop.shipping_after_days : "",
          gtagId: shop.gtag_id ? shop.gtag_id : "",
          isShoppaymentEnabled: (shop.is_shoppayment_enabled) ?  1 : 0,
          gtmId: "",
          facebookPixelId: "",
          twitterPixelId: "",
          default_country: shop.default_country ? shop.default_country : 0,
        })
        setLogoPreview(process.env.REACT_APP_ASSET_URL + shop.logo_url);
        setFaviconPreview(process.env.REACT_APP_ASSET_URL + shop.favicon_url);
        if (shop.info_imgs) {
          setImageUpdateInfo(shop.info_imgs);
          setImagePreview(shop.info_imgs.map((img) => {
            return process.env.REACT_APP_ASSET_URL + img;
          }));
        }
        if (shop.info_urls)
          setUrlUpdateInfo(shop.info_urls);

        updateEffects(shop.original_effect_pattern, effectType)

      }).catch(error => {
        window.location.href = '/' + shop;
      });
  }

  const updateEffects = (originals, effectType) => {
    console.log(originals, effectType)
    if (shopInfo.effectType <= 1000) {
      setEffects([
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-1.mp4`,
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-2.mp4`,
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-3.mp4`,
        `${process.env.REACT_APP_ASSET_URL}/static/gacha-effect/gacha_effect${shopInfo.effectType}-4.mp4`,
      ]);
    } else {
      if (originals) {
        const original = originals.find(o => o.id === Number(effectType));
        if (original) {
          setEffects([
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 1)?.path_with_version}`,
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 2)?.path_with_version}`,
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 3)?.path_with_version}`,
            `${process.env.REACT_APP_ASSET_URL}${original.items.find(i => i.rank === 4)?.path_with_version}`,
          ]);
        }
      }
    }
  }

  useEffect(() => {
    getShop()
  }, [])

  const [shopInfo, setShopInfo] = useState({
    userId: '',
    name: '',
    address: '',
    email: '',
    password: '',
    url: '',
    postalCode: '',
    address: '',
    personInCharge: '',
    specialCommercialLaw: '',
    privacyPolicy: '',
    useTerm: '',
    userPaymentTerms: '',
    platformCardPurchaseTerms: '',
    secondhandDealerLicenseNumber: '',
    faviconUrl: '',
    logoUrl: '',
    designType: 1,
    effectType: 1,
    shipFee: 0,
    noteTitle: "",
    noteContent: "",
    holdDays: "",
    shippingAfterDays: "",
    gtagId: "",
    isShoppaymentEnabled: 0,
    gtmId: "",
    facebookPixelId: "",
    twitterPixelId: "",
    default_country: 0,
  });

  useEffect(() => {
    updateEffects(shopInfo.originalEffectPattern, shopInfo.effectType)
  }, [shopInfo])

  const [imageUpdateInfo, setImageUpdateInfo] = useState([]);
  const [urlUpdateInfo, setUrlUpdateInfo] = useState([]);

  const [confirm, setConfirm] = useState(false);
  
  const backShopInfo = (e) => {
    window.location.href = '/' + shop + '/shop';
  }

  const confirmShopInfo = (e) => {
    
    const shop = document.getElementsByClassName('shop')[0];
    shop.scrollTo(0, 0);

    const data = {
      shop_user_id: shopInfo.userId,
      name: shopInfo.name,
      address: shopInfo.address,
      email: shopInfo.email,
      url: shopInfo.url,
      postal_code: shopInfo.postalCode,
      address: shopInfo.address,
      person_in_charge: shopInfo.personInCharge,
      special_commercial_law: shopInfo.specialCommercialLaw,
      privacy_policy: shopInfo.privacyPolicy,
      use_terms: shopInfo.useTerm,
      user_payment_terms: shopInfo.userPaymentTerms,
      platform_card_purchase_terms: shopInfo.platformCardPurchaseTerms,
      secondhand_dealer_license_number: shopInfo.secondhandDealerLicenseNumber,
      design_pattern: shopInfo.designType,
      effect_pattern: shopInfo.effectType,
      ship_fee: shopInfo.shipFee,
      note_title: shopInfo.noteTitle,
      note_content: shopInfo.noteContent,
      gtag_id: shopInfo.gtagId,
      is_shoppayment_enabled: shopInfo.isShoppaymentEnabled,
      gtm_id: "",
      facebook_pixel_id: "",
      twitter_pixel_id: "",
      default_country: shopInfo.default_country,
    };

    if (shopInfo.holdDays) {
      data.hold_days = shopInfo.holdDays;
    }

    if (shopInfo.shippingAfterDays) {
      data.shipping_after_days = shopInfo.shippingAfterDays;
    }

    if (shopInfo.password && shopInfo.password.length > 0)
      data.password = shopInfo.password;

    const body = new FormData();
    Object.keys(data).forEach(key => {
      body.append(key, data[key]);
    });
    if (logo)
      body.append('logo', logo);
    if (favicon)
      body.append('favicon', favicon);
    if (image.length > 0)
      for (let i = 0; i < 5; i++) {
        if (image[i])
          body.append('info_imgs[]', image[i]);
      }
    if (urlUpdateInfo.length > 0)
      for (let i = 0; i < 5; i++) {
        if (urlUpdateInfo[i])
          body.append('info_urls[]', urlUpdateInfo[i]);
      }


    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
      xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
      token = token.split('=')[1]
    }
    fetch(process.env.REACT_APP_API_URL + '/api/shop-edit-confirm', {
      method: 'POST',
      cache: 'no-store',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
      body,
    }).then(response => {
      if (response.status === 200) {
        setConfirm(true);
      } else {
      }
      return response.json();
    })
      .then(data => {
        if (data.errors) {
          alert(Object.values(data.errors)[0]);
        }
      })
      .catch(error => {
        alert(error);
      });
  }

  const confirmBackShopInfo = (e) => {
    const shop = document.getElementsByClassName('shop')[0];
    shop.scrollTo(0, 0);
    setConfirm(false);
  }

  const saveShopInfo = (e) => {
    const data = {
      shop_user_id: shopInfo.userId,
      name: shopInfo.name,
      address: shopInfo.address,
      email: shopInfo.email,
      url: shopInfo.url,
      postal_code: shopInfo.postalCode,
      address: shopInfo.address,
      person_in_charge: shopInfo.personInCharge,
      special_commercial_law: shopInfo.specialCommercialLaw,
      privacy_policy: shopInfo.privacyPolicy,
      use_terms: shopInfo.useTerm,
      user_payment_terms: shopInfo.userPaymentTerms,
      platform_card_purchase_terms: shopInfo.platformCardPurchaseTerms,
      secondhand_dealer_license_number: shopInfo.secondhandDealerLicenseNumber,
      design_pattern: shopInfo.designType,
      effect_pattern: shopInfo.effectType,
      ship_fee: shopInfo.shipFee,
      note_title: shopInfo.noteTitle,
      note_content: shopInfo.noteContent,
      gtag_id: shopInfo.gtagId,
      is_shoppayment_enabled: shopInfo.isShoppaymentEnabled,
      gtm_id: "",
      facebook_pixel_id: "",
      twitter_pixel_id: "",
      default_country: shopInfo.default_country,
    };

    if (shopInfo.holdDays) {
      data.hold_days = shopInfo.holdDays;
    }

    if (shopInfo.shippingAfterDays) {
      data.shipping_after_days = shopInfo.shippingAfterDays;
    }

    if (shopInfo.password && shopInfo.password.length > 0)
      data.password = shopInfo.password;

    const body = new FormData();
    Object.keys(data).forEach(key => {
      body.append(key, data[key]);
    });
    if (logo)
      body.append('logo', logo);
    if (favicon)
      body.append('favicon', favicon);
    if (image.length > 0)
      for (let i = 0; i < 5; i++) {
        if (image[i])
          body.append('info_imgs[' + i + ']', image[i]);
      }
    if (urlUpdateInfo.length > 0)
      for (let i = 0; i < 5; i++) {
        if (urlUpdateInfo[i])
          body.append('info_urls[' + i + ']', urlUpdateInfo[i]);
      }

    let xsrfToken = document.cookie.split('; ').find(row => row.startsWith(process.env.REACT_APP_XSRF_TOKEN));
    if (xsrfToken) {
      xsrfToken = xsrfToken.split('=')[1]
    }
    let token = document.cookie.split('; ').find(row => row.startsWith('token'));
    if (token) {
      token = token.split('=')[1]
    }
    fetch(process.env.REACT_APP_API_URL + '/api/shop-edit', {
      method: 'POST',
      headers: {
        'X-XSRF-TOKEN': decodeURIComponent(xsrfToken),
        'Bearer': decodeURIComponent(token)
      },
      credentials: 'include',
      body,
    }).then(response => {
      if (response.status === 200) {
        alert(t('shop_edit.saved'));
        backShopInfo();
      } else {
        alert(t('shop_edit.error1'));
      }
    }).catch(error => {
      alert(t('shop_edit.error1'));
    });
  }

  const [logo, setLogo] = useState(null);
  const [favicon, setFavicon] = useState(null);

  const [logoPreview, setLogoPreview] = useState(null);
  const [faviconPreview, setFaviconPreview] = useState(null);
  
  const handleChangeLogo = (e) => {
    let file = e.target.files[0];
    setLogo(file);
    let reader = new FileReader();
    reader.onload = () => {
      setLogoPreview(reader.result);
    }
    reader.readAsDataURL(file);
  }

  const handleChangeFavicon = (e) => {
    let file = e.target.files[0];
    setFavicon(file);
    let reader = new FileReader();
    reader.onload = () => {
      setFaviconPreview(reader.result);
    }
    reader.readAsDataURL(file);
  }

  const [image, setImage] = useState([]);
  const [imagePreview, setImagePreview] = useState([]);

  useEffect(() => {
    setImagePreview(imageUpdateInfo);
  }, []);

  const handleChangeImage = (e) => {
    let index = e.target.name;

    setImage((image) => {
      image[index] = e.target.files[0];
      return image;
    });

    let imageList = [...imagePreview];
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.onload = () => {
      imageList[index] = reader.result;
      setImagePreview(imageList);
    }
    reader.readAsDataURL(file);
  }

  const handleChangeUrl = (e) => {
    let index = e.target.name;

    setUrlUpdateInfo((urlUpdateInfo) => {
      urlUpdateInfo[index] = e.target.value;
      return urlUpdateInfo;
    });
  }

  const CreateShopUpdateInfo = ({ }) => {
    
    return [...Array(5)].map((_, i) => {
      return (
        <div className="shop-info-img-wrapper" key={"shop-info-img-wrapper"+i}>
          {confirm && urlUpdateInfo[i] &&
            <>
              <div className="shop-info-img">
                {confirm && <img src={imagePreview[i]} />}
              </div>
              {confirm && <>{urlUpdateInfo[i]}</>}
            </>
          }
          {!confirm &&
            <>
              <div className="shop-info-img">
                {!confirm && <img src={imagePreview[i]} onClick={() => document.getElementById(`update-info-${i}`).click()} />}
                {!confirm && <input className="shop-info-input" type="file" onChange={handleChangeImage} name={i} id={`update-info-${i}`} style={{ display: 'none' }} />}
              </div>
              {!confirm && <input className="shop-info-input" type="text" defaultValue={urlUpdateInfo[i]} onChange={handleChangeUrl} name={i} placeholder={t('shop_edit.news_placeholder')} />}
            </>
          }
        </div>
      );
    });
  }

  return (
    <>
      <Header />
      <SideMenu onlyShop={onlyShop} />
      <div className="shop">
        <div className="shop-content">
          <div className="shop-title">{t('shop.title1')}</div>
          <div className='clearfix'></div>
          <div className="shop-sub-title">{t('shop.information')}</div>
          <dl className="shop-info">
            <dt className="shop-info-title">{t('shop_edit.logo')}<span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <img className="shop-info-image" src={logoPreview} />
                </>
                :
                <>
                  <img className="shop-info-image" src={logoPreview} />
                  <input className="shop-logo-input" accept="image/*" type="file" onChange={handleChangeLogo} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop_edit.favicon')}<span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <img className="shop-info-favicon" src={faviconPreview} />
                </>
                :
                <>
                  <img className="shop-info-favicon" src={faviconPreview} />
                  <input className="shop-fav-input" accept="image/*" type="file" onChange={handleChangeFavicon} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.id')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.userId}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.userId} onChange={e => setShopInfo({ ...shopInfo, userId: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.password')}</dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  ********
                </>
                :
                <>
                  <input className="shop-info-input" type="password" value={shopInfo.password ?? ''} onChange={e => setShopInfo({ ...shopInfo, password: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.name')}<span className="shop-require">*</span><span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.name}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.name} onChange={e => setShopInfo({ ...shopInfo, name: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.default_country')}</dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.default_country == "0" ? "日本"
                    : shopInfo.default_country == "1" ? "香港"
                    : shopInfo.default_country == "2" ? "台湾"
                    : shopInfo.default_country == "3" ? "シンガポール"
                    : "日本"
                  }
                </>
                :
                <>
                  <select className="shop-info-input" value={shopInfo.default_country} onChange={e => setShopInfo({ ...shopInfo, default_country: e.target.value })}>
                    <option value="0">日本</option>
                    <option value="1">香港</option>
                    <option value="2">台湾</option>
                    <option value="3">シンガポール</option>
                  </select>
                </>
              }
            </dd>

            <dt className="shop-info-title">{t('shop.postal_code')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.postalCode}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.postalCode} onChange={e => setShopInfo({ ...shopInfo, postalCode: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.address')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.address}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.address} onChange={e => setShopInfo({ ...shopInfo, address: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.email')}<span className="shop-require">*</span><span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.email}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.email} onChange={e => setShopInfo({ ...shopInfo, email: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.url')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.url}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.url} onChange={e => setShopInfo({ ...shopInfo, url: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.manager')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.personInCharge}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.personInCharge} onChange={e => setShopInfo({ ...shopInfo, personInCharge: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.law')}<span className="shop-require">*</span><span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <textarea className="shop-info-textarea" value={ shopInfo.specialCommercialLaw ?? ''} readOnly />
                </>
                :
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.specialCommercialLaw ?? ''} onChange={e => setShopInfo({ ...shopInfo, specialCommercialLaw: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.privacy')}<span className="shop-require">*</span><span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.privacyPolicy ?? ''} readOnly />
                </>
                :
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.privacyPolicy ?? ''} onChange={e => setShopInfo({ ...shopInfo, privacyPolicy: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.service')}<span className="shop-require">*</span><span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.useTerm ?? ''} readOnly />
                </>
                :
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.useTerm ?? ''} onChange={e => setShopInfo({ ...shopInfo, useTerm: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">ユーザー入金規約<span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.userPaymentTerms ?? ''} readOnly />
                </>
                :
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.userPaymentTerms ?? ''} onChange={e => setShopInfo({ ...shopInfo, userPaymentTerms: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">プラットフォームカード購入規約<span className="shop-public">{t('shop_edit.publish')}</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.platformCardPurchaseTerms ?? ''} readOnly />
                </>
                :
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.platformCardPurchaseTerms ?? ''} onChange={e => setShopInfo({ ...shopInfo, platformCardPurchaseTerms: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.number')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.secondhandDealerLicenseNumber}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.secondhandDealerLicenseNumber} onChange={e => setShopInfo({ ...shopInfo, secondhandDealerLicenseNumber: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.point')}<span className="shop-require">*</span></dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.shipFee}
                </>
                :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.shipFee} onChange={e => setShopInfo({ ...shopInfo, shipFee: e.target.value })} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.Pending')}</dt>
            <dd className="shop-info-text">
              {confirm ?
                  shopInfo.holdDays ? 
                    <>
                    {t('shop.day1')} {shopInfo.holdDays} {t('shop.day2')}
                    </>
                  :
                    <>
                    {t('shop.deadline')}
                    </>
              :
                <>
                  {t('shop.day1')} <input className="shop-info-input" type="text" value={shopInfo.holdDays} onChange={e => setShopInfo({...shopInfo, holdDays: e.target.value})} placeholder={t('shop_edit.deadline')}/> {t('shop.day2')}
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.days')}</dt>
            <dd className="shop-info-text">
              {confirm ?
                  shopInfo.shippingAfterDays ?
                    <>
                    {t('shop.day1')} {shopInfo.shippingAfterDays} {t('shop.day2')}({t('shop.note')})
                    </>
                  :
                    <>
                    {t('shop.none')}
                    </>
              :
                <>
                  {t('shop.day1')} <input className="shop-info-input" type="text" value={shopInfo.shippingAfterDays} onChange={e => setShopInfo({...shopInfo, shippingAfterDays: e.target.value})} placeholder={t('shop_edit.none')}/> {t('shop.day2')}
                </>
              }
            </dd>
          </dl>
          <div className="line"></div>
          <div className="shop-sub-title">{t('shop.display')}</div>
          <dl className="shop-info">
            <dt className="shop-info-title">{t('shop_edit.news')}</dt>
            <dd className="shop-info-text">
              {!confirm &&
                <p className="shop-info-description">{t('shop_edit.news_description')}</p>
              }
              <div className="shop-info-imgs">
                <CreateShopUpdateInfo />
              </div>
            </dd>
            <dt className="shop-info-title">{t('shop.design')}</dt>
            <dd className="shop-info-text">
              {!confirm ?
                <>
                  <div className="shop-design-img">
                    <input className="shop-design-radio" type="radio" onChange={e => setShopInfo({ ...shopInfo, designType: 1 })} checked={shopInfo.designType === 1} />
                    <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern1.png`} alt={t('shop.design')} />
                    {t('shop_edit.pattern1')}
                  </div>
                  <div className="shop-design-img">
                    <input className="shop-design-radio" type="radio" onChange={e => setShopInfo({ ...shopInfo, designType: 2 })} checked={shopInfo.designType === 2} />
                    <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern2.png`} alt={t('shop.design')} />
                    {t('shop_edit.pattern2')}
                  </div>
                  <div className="shop-design-img">
                    <input className="shop-design-radio" type="radio" onChange={e => setShopInfo({ ...shopInfo, designType: 3 })} checked={shopInfo.designType === 3} />
                    <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern3.png`} alt={t('shop.design')} />
                    {t('shop_edit.pattern3')}
                  </div>
                  <div className="shop-design-img">
                    <input className="shop-design-radio" type="radio" onChange={e => setShopInfo({ ...shopInfo, designType: 4 })} checked={shopInfo.designType === 4} />
                    <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern4.png`} alt={t('shop.design')} />
                    {t('shop_edit.pattern4')}
                  </div>
                  <div className="shop-design-img">
                    <input className="shop-design-radio" type="radio" onChange={e => setShopInfo({ ...shopInfo, designType: 5 })} checked={shopInfo.designType === 5} />
                    <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern5.png`} alt={t('shop.design')} />
                    {t('shop_edit.pattern5')}
                  </div>
                </>
                :
                <>
                  <div className="shop-design-img">
                    <img src={`${process.env.REACT_APP_ASSET_URL}/static/design-pattern/design_pattern${shopInfo.designType}.png`} alt={t('shop.design')} />
                    {t('shop_edit.pattern')}{shopInfo.designType}
                  </div>
                </> 
              }
            </dd>
            <dt className="shop-info-title">{t('shop.effect')}</dt>
            <dd className="shop-info-text">
              <div className="shop-effect-imgs">
                {effects.map((e, index) => (
                  <div className="shop-effect-img" key={"shop-effect-img"+index}>
                    <video src={e} autoPlay muted loop playsInline></video>
                    {index + 1}{t('shop.rank')}
                  </div>
                ))}
              </div>
              {!confirm && <button className="shop-effect-button" onClick={openModal}>{t('shop_edit.select')}</button>}
            </dd>
            <dt className="shop-info-title">{t('shop.gache1')}</dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.noteTitle}
                </>
              :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.noteTitle} onChange={e => setShopInfo({...shopInfo, noteTitle: e.target.value})} />
                </>
              }
            </dd>
            <dt className="shop-info-title">{t('shop.gache2')}</dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  <textarea className="shop-info-textarea" readOnly value={shopInfo.noteContent ?? ''} />
                </>
              :
                <>
                  <textarea className="shop-info-textarea" value={shopInfo.noteContent ?? ''} onChange={e => setShopInfo({...shopInfo, noteContent: e.target.value})} />
                </>
              }
            </dd>
            <dt className="shop-info-title">Google Analytics ID</dt>
            <dd className="shop-info-text">
              {confirm ?
                <>
                  {shopInfo.gtagId}
                </>
              :
                <>
                  <input className="shop-info-input" type="text" value={shopInfo.gtagId} onChange={e => setShopInfo({...shopInfo, gtagId: e.target.value})} />
                </>
              }
            </dd>
          </dl>
        </div>
        <div className="clearfix"></div>
        <div className="shop-button">
          {confirm ?
            <>
              <button className="shop-button-back" onClick={confirmBackShopInfo}>{t('shop_edit.back')}</button>
              <button className="shop-button-save" onClick={saveShopInfo}>{t('shop_edit.sava')}</button>
            </>
            :
            <>
              <button className="shop-button-back" onClick={backShopInfo}>{t('shop_edit.back')}</button>
              <button className="shop-button-save" onClick={confirmShopInfo}>{t('shop_edit.confirm')}</button>
            </>
          }
        </div>
      </div>
      <GachaEffect 
        modalIsOpen={isGachaEffectModalOpen}
        closeModal={closeModal}
        shopInfo={shopInfo}
        setShopInfo={setShopInfo}
        getShop={getShop}
      />
    </>
  )
}

export default ShopEdit